module.exports = __webpack_public_path__ + "static/media/edit_black.1ebe58e9.svg";